import { AppRegistry } from 'react-native';
import App from './App';

// Suppress known React Query + StrictMode AbortController errors in development
// These occur when React 18 StrictMode double-mounts components with in-flight requests
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  // Suppress console.error for this message
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes?.('signal is aborted without reason')) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress uncaught errors for this message (webpack dev server overlay)
  window.addEventListener('error', (event) => {
    if (event.message?.includes?.('signal is aborted without reason')) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });

  // Suppress unhandled promise rejections for AbortError
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message?.includes?.('signal is aborted without reason') ||
        event.reason?.name === 'AbortError') {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });
}

// Register the app
AppRegistry.registerComponent('llysto', () => App);

// Run the app in the browser
AppRegistry.runApplication('llysto', {
  rootTag: document.getElementById('root'),
});
